$.widget("bluaul.vcSetLogger",
{
    // <summary>
    // Switches the user to the given logger and shows some intermediate infos while loading
    // Author: AFU<br />
    // Date: 21.9.2021<br />
    // Copyright ©: EUDT GmbH 2021 <br />
    // Version-History:<br />
    // **********************************************************************<br />
    // * - basic functionality                                              *<br />
    // **********************************************************************<br />
    // </summary>

    options: {blid:-1},
  

    _create: function () {

        var me = this;
        var pos = { my: 'top+50%', at: 'top', of: window };
        var d = $('<p>').html("<h3>Changing project ...</h3><br/>Please wait until the page is reloaded!").dialog({
            position: pos, modal: true,
            dialogClass: 'saveDialog',
            open: function() {
                window.VisualCoreService.setLogger(me.options.blid, window.location.href, function (result) {
                    if (result === null) { ; return false; }
                    location.reload();
                    return true;
                });

            }
        });
        //me.visual.find(".op-entries").css("opacity", "0.5!important");
      

        return true;
    }
  
});
